<div class="formfield">
  <div [formGroup]="userForm">
    <nes-input type="text"
      [label]="'INPUT.MIDDLENAME.LABEL' | translate"
      [name]="'INPUT.MIDDLENAME.NAME' | translate"
      [placeholder]="'INPUT.MIDDLENAME.PLACEHOLDER' | translate"
      [value]="formGroup.get('middleName')!.value"
      formControlName="middleName"
      nesFormControl
      [cypress]="'middle_name'"
      forceLowercase
      receiptFooterVisibility
      privacySensitive
      controlled
      nes-id="middle_name"
      (nesOnChange)="_uiService.isIgnoreNumbersInLastName($event)"
      ></nes-input>
      <div *ngIf="isTouched('middleName') && hasError('middleName', 'middleName')">
        <ng-container>
          <nes-error-message>
            {{ "INPUT.MIDDLENAME.ERROR_INVALID" | translate }}
          </nes-error-message>
        </ng-container>
      </div>
  </div>
</div>